import pickSlot from '../assets/release-2026-10-27/termin-planen-01-zeit-waehlen.png'
import save from '../assets/release-2026-10-27/termin-planen-02-termin-anlegen.png'
import details from '../assets/release-2026-10-27/termin-planen-03-details.png'
import { makeBox, type GuideStepContent } from './guideStep'

/** Desktop screenshots, 1920×1080. */
const box = makeBox(1920, 1080)

export const TERMIN_PLANEN_INTRO =
  'Ein neuer Auftrag führt direkt in den Kalender. Dort speichern Sie den Termin mit einem Klick — oder öffnen die Details für weitere Angaben.'

export const TERMIN_PLANEN_STEPS: GuideStepContent[] = [
  {
    title: 'Zeit im Kalender wählen',
    text: 'Klicken Sie bei „Neuer Auftrag“ auf „Anlegen und planen“ — oder im Auftrag auf „Termin planen“ bzw. „Folgetermin planen“. Der Kalender öffnet sich, unten steht eine Leiste mit dem Auftrag. Klicken Sie in die Zeile eines Handwerkers zur gewünschten Uhrzeit.',
    image: pickSlot,
    imageAlt: 'Kalender beim Planen mit der Leiste unten',
    focus: [box(915, 395, 1095, 472), box(332, 932, 1886, 1008)],
    wide: true,
  },
  {
    title: 'Mit „Termin anlegen“ sofort speichern',
    text: 'Der Termin erscheint im Kalender. Die Leiste zeigt Handwerker, Tag, Uhrzeit und die Minuten für Anfahrt, Arbeit und Abfahrt. Klicken Sie auf „Termin anlegen“ — fertig, der Termin ist gespeichert.',
    note: {
      title: 'Rote oder gelbe Meldung?',
      text: '„Überschneidung mit einem bestehenden Eintrag“ oder „Außerhalb der Arbeitszeit“: Prüfen Sie den Platz, bevor Sie speichern.',
    },
    image: save,
    imageAlt: 'Neuer Termin im Kalender, Knopf „Termin anlegen“ in der Leiste',
    focus: [box(957, 320, 1231, 381), box(352, 972, 640, 996), box(1506, 946, 1694, 994)],
    wide: true,
  },
  {
    title: 'Mehr Angaben über „Details“',
    text: 'Für weitere Angaben klicken Sie neben „Termin anlegen“ auf „Details“. Das Formular öffnet sich neben dem Kalender, Handwerker und Zeit sind schon eingetragen. Speichern Sie dort mit „Termin anlegen“. Mit dem X in der Leiste oder im Formular brechen Sie ab.',
    image: details,
    imageAlt: 'Formular „Neuer Termin“ neben dem Kalender',
    focus: [box(1135, 946, 1244, 994), box(1380, 1014, 1900, 1060)],
    wide: true,
  },
]
